import React from 'react';
import { motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { Doodles, DoodleSpec } from './Doodles';
import { ConfettiRain } from './ConfettiRain';
import { images } from '../data/bonuses';
const heroDoodles: DoodleSpec[] = [{
  kind: 'star',
  top: '5%',
  left: '4%',
  size: 28,
  color: '#F6C453',
  rotate: -8
}, {
  kind: 'confetti',
  top: '14%',
  left: '92%',
  size: 15,
  color: '#F27C70',
  rotate: 24
}, {
  kind: 'sparkle',
  top: '48%',
  left: '2%',
  size: 20,
  color: '#6CBBD5'
}, {
  kind: 'crayon',
  top: '72%',
  left: '94%',
  size: 32,
  color: '#F3A340',
  rotate: 18
}, {
  kind: 'dot',
  top: '86%',
  left: '8%',
  size: 11,
  color: '#2D8C5A'
}, {
  kind: 'sparkle',
  top: '90%',
  left: '88%',
  size: 18,
  color: '#F3A340'
}];
const tags = [{
  label: 'Manualidades',
  color: '#F27C70'
}, {
  label: 'Juegos',
  color: '#6CBBD5'
}, {
  label: 'Experimentos',
  color: '#2D8C5A'
}, {
  label: 'Retos',
  color: '#F3A340'
}];
export function Hero() {
  const reduce = useReducedMotion();
  return <section className="relative w-full overflow-hidden bg-cream" aria-labelledby="hero-title" data-id="element-184" data-mp="3o6apvvoqw6zy">
      <ConfettiRain count={34} opacity={0.85} data-id="element-185" data-mp="399jmzcfv4d5l" />
      <Doodles specs={heroDoodles} data-id="element-186" data-mp="39cpfl1np9x62" />

      <div className="relative z-10 mx-auto grid max-w-content grid-cols-1 items-center gap-10 px-5 pb-14 pt-10 sm:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-8 lg:pb-24 lg:pt-20" data-id="element-187" data-mp="3e8mqgsg72bbg">
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-188" data-mp="358hoixtrs54o">
          <motion.span className="inline-flex rounded-full bg-mint px-4 py-1.5 font-display text-[11px] font-extrabold uppercase tracking-[0.16em] text-brandgreen" animate={reduce ? undefined : {
          y: [0, -4, 0]
        }} transition={{
          duration: 3.4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-189" data-mp="2qk3k4igpg8m0">
            365 ideas para todo el año
          </motion.span>

          <h1 id="hero-title" className="mt-5 font-display text-[2.5rem] font-extrabold uppercase leading-[0.98] tracking-tight text-navy sm:text-[3.4rem] lg:text-[4.35rem]" data-id="element-190" data-mp="s21hwapu6bzg">
            Haz del <span className="text-tangerine" data-id="element-191" data-mp="ibp02q9eowx0">tiempo libre</span> un momento para{' '}
            <span className="text-brandgreen" data-id="element-192" data-mp="ddf2k907lk88">crear juntos</span>
          </h1>

          <p className="mt-4 max-w-md font-sans text-base leading-relaxed text-muted sm:text-lg" data-id="element-193" data-mp="dbar95zzdixx">
            365 ideas listas para jugar, crear y divertirse en casa. Solo abre, elige y
            empiezan.
          </p>

          <ul className="mt-5 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-194" data-mp="112g7vndqwf9a">
            {tags.map(t => <li key={t.label} className="rounded-full px-3 py-1.5 font-display text-[11px] font-extrabold uppercase tracking-wide text-white" style={{
            backgroundColor: t.color
          }} data-id="element-195" data-mp="x1wbim0zxfo7">
                {t.label}
              </li>)}
          </ul>
          <p className="mt-2 font-sans text-xs text-muted" data-id="element-196" data-mp="1xam4cnf59kxc">Para niños de 4 a 10 años.</p>

          <div className="mt-7 w-full" data-id="element-197" data-mp="21bxx31tbem9r">
            <PriceBlock align="responsive" data-id="element-198" data-mp="218jwnz47on4y" />
          </div>

          <div className="mt-6" data-id="element-199" data-mp="2697mihgpexxl">
            <CTAButton data-id="element-200" data-mp="267wjijv31u7j">Quiero las 365 ideas</CTAButton>
          </div>

          <p className="mt-4 font-display text-[11px] font-extrabold uppercase tracking-[0.08em] text-navy/70 sm:text-xs" data-id="element-201" data-mp="2b1hh4asrkm67">
            + 10 bonos gratis · + Pasaporte Creativo · + Acceso inmediato
          </p>
          <p className="mt-2 font-sans text-xs text-muted" data-id="element-202" data-mp="2kx2flyymj4b7">Pago único • Sin suscripciones</p>
        </div>

        <motion.div className="relative flex justify-center lg:justify-end" animate={reduce ? undefined : {
        y: [0, -12, 0],
        rotate: [-1.2, 1.4, -1.2]
      }} transition={{
        duration: 9,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-203" data-mp="2p1a9eajxvaga">
          <div className="absolute inset-x-8 bottom-6 h-10 rounded-[50%] bg-navy/10 blur-2xl" data-id="element-204" data-mp="zmluo2nvlgf3" />
          <img src={images.bundle} alt="El Gran Reto Creativo rodeado de los 10 libros de bonos incluidos" className="relative h-auto w-full max-w-[560px] rounded-[2rem] shadow-card" width={1456} height={1092} loading="eager" fetchPriority="high" decoding="sync" data-id="element-205" data-mp="4akzf5h4mwj5" />
        </motion.div>
      </div>
    </section>;
}